import React, {forwardRef, useState} from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import {curry} from 'ramda';
import {useHistory} from 'react-router-dom';
import wrap from 'wraptile';

import {ADMIN_LINKS} from './AdminLinks';
import AppSidebarAdminLinksMenu from './AppSidebarAdminLinksMenu';

export const mapWithProps = curry((setAnchorEl, history, option) => {
    const onLinkClick = handleLinkClick({
        setAnchorEl,
        history,
        selectedRoute: option.route,
    });
    
    return (
        <MenuItem
            key={option.title}
            selected={history.location.pathname === option.route}
            onClick={onLinkClick}
        >
            {option.title}
        </MenuItem>
    );
});

export const handleLinkClick = wrap((handlers: any) => {
    const {
        setAnchorEl,
        history,
        selectedRoute,
    } = handlers;
    
    setAnchorEl(null);
    history.push(selectedRoute);
});

export const handleAnchorSet = curry((setAnchorEl, event) => {
    setAnchorEl(event.currentTarget);
});

export const handleClose = wrap((setAnchorEl: any) => {
    setAnchorEl(null);
});

const AppSidebarAdminLinksMenuContainer = forwardRef((props, ref) => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'className' does not exist on type '{ chi... Remove this comment to see the full error message
    const {className} = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const history = useHistory();
    const isOpen = Boolean(anchorEl);
    
    const handleClickListItem = handleAnchorSet(setAnchorEl);
    const onClose = handleClose(setAnchorEl);
    
    const withProps = mapWithProps(setAnchorEl, history);
    const links = ADMIN_LINKS.map(withProps);
    
    return (
        <AppSidebarAdminLinksMenu
            ref={ref}
            // @ts-expect-error ts-migrate(2322) FIXME: Property 'className' does not exist on type 'Intri... Remove this comment to see the full error message
            className={className}
            handleClickListItem={handleClickListItem}
            anchorEl={anchorEl}
            isOpen={isOpen}
            onClose={onClose}
            links={links}
        />
    );
});

export default AppSidebarAdminLinksMenuContainer;
